import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ref"],
    _excluded2 = ["selectProps", "data"],
    _excluded3 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import theme from 'styled-theming';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
import { components } from 'react-select';
import { default as ReactSelect } from 'react-select';
import { default as ReactSelectAsync } from 'react-select/async';
import { default as ReactSelectCreatable } from 'react-select/creatable';
import { default as ReactSelectAsyncCreatable } from 'react-select/async-creatable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ClearIndicator = function ClearIndicator(props) {
  var getStyles = props.getStyles,
      _props$innerProps = props.innerProps,
      ref = _props$innerProps.ref,
      restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded);

  return _jsx("div", _objectSpread(_objectSpread({}, restInnerProps), {}, {
    ref: ref,
    style: getStyles('clearIndicator', props),
    className: "".concat(prefix, "-select__clear"),
    children: _jsx(Icon, {
      icon: "cross",
      color: "var(--dentsu-color-b550)",
      size: 16
    })
  }));
},
    ClearIndicatorStyles = function ClearIndicatorStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    cursor: 'pointer',
    pointerEvents: 'all',
    zIndex: 1
  });
};
export var SelectContainerStyles = function SelectContainerStyles(base, props) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 0,
    opacity: props.isDisabled ? 0.4 : 1,
    pointerEvents: 'all'
  });
};
export var ControlStyles = function ControlStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: state.isFocused ? 'var(--dentsu-color-white)' : state.selectProps.isInvalid ? 'var(--dentsu-color-r100)' : state.selectProps.mode === 'light' ? 'var(--dentsu-color-n50)' : 'var(--dentsu-color-white)',
    boxShadow: state.isFocused ? 'inset 0 1px 0 0 var(--dentsu-color-f500), var(--dentsu-shadow-8)' : state.selectProps.isInvalid ? 'inset 0 1px 0 0 var(--dentsu-color-r600)' : 'inset 0 1px 0 0 var(--dentsu-color-n300)',
    borderColor: 'transparent',
    borderWidth: 0,
    borderRadius: 0,
    color: 'var(--dentsu-color-n1000)',
    minHeight: rem(40),
    ':hover': {
      backgroundColor: state.isFocused ? 'var(--dentsu-color-white)' : state.selectProps.isInvalid ? 'var(--dentsu-color-r150)' : state.selectProps.mode === 'light' ? 'var(--dentsu-color-n100)' : 'var(--dentsu-color-white)',
      cursor: state.selectProps.isDisabled ? 'not-allowed' : 'default'
    }
  });
};
export var DropdownIndicator = function DropdownIndicator(props) {
  return _jsx(components.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx(Icon, {
      icon: props.selectProps.menuIsOpen ? 'chevron-up' : 'chevron-down',
      color: "var(--dentsu-color-b550)",
      size: 16
    })
  }));
};
export var IndicatorsContainerStyles = function IndicatorsContainerStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    paddingRight: 'var(--dentsu-spacing-8)',
    paddingTop: 'var(--dentsu-spacing-4)',
    alignItems: 'flex-start',
    svg: {
      fill: 'var(--dentsu-color-b550)'
    }
  });
};
export var IndicatorSeparator = function IndicatorSeparator() {
  return false;
};
export var MenuStyles = function MenuStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    borderRadius: 0,
    boxShadow: 'var(--dentsu-shadow-8)',
    marginTop: 0,
    zIndex: 999
  });
};
export var MenuPortalStyles = function MenuPortalStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    zIndex: 9999,
    '.dentsu-select__menu > div': {
      overflowY: 'auto'
    }
  });
};
export var MenuListStyles = function MenuListStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    paddingTop: 0,
    paddingBottom: 0
  });
};
export var MenuListBlockScrollStyles = function MenuListBlockScrollStyles(base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    paddingTop: 0,
    paddingBottom: 0,
    overflowY: 'initial'
  });
};
var CustomOption = styled.div.withConfig({
  displayName: "Selectstyles__CustomOption",
  componentId: "sc-p8f04v-0"
})(["margin-bottom:0;min-height:", ";font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-regular);letter-spacing:var(--dentsu-tracking-normal);line-height:var(--dentsu-leading-tight);position:relative;display:block;"], rem(24));
var CustomIndicator = styled.span.withConfig({
  displayName: "Selectstyles__CustomIndicator",
  componentId: "sc-p8f04v-1"
})(["display:inline-block;user-select:none;vertical-align:middle;cursor:pointer;border:none;border-radius:0;width:", ";height:", ";transition:all var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-entrance);margin-top:0;margin-right:0;margin-left:0;position:absolute;box-shadow:inset 0 0 0 ", " var(--dentsu-color-n500),inset 0 0 0 ", " var(--dentsu-color-white);background:var(--dentsu-color-n200);", " &:before{display:block;content:'';background-image:none;", "}"], rem(24), rem(24), rem(1), rem(4), function (props) {
  return props.isChecked && css(["box-shadow:inset 0 0 0 ", " var(--dentsu-color-b550),inset 0 0 0 ", " var(--dentsu-color-white);background:var(--dentsu-color-n200);"], rem(2), rem(5));
}, function (props) {
  return props.isChecked ? css(["width:", ";height:", ";transform:rotate(-45deg);position:absolute;left:", ";top:", ";border-left:", " solid var(--dentsu-color-b550);border-bottom:", " solid var(--dentsu-color-b550);"], rem(12), rem(8), rem(6), rem(6), rem(3), rem(3)) : css(["width:1em;height:1em;"]);
});
var CustomLabel = styled.label.withConfig({
  displayName: "Selectstyles__CustomLabel",
  componentId: "sc-p8f04v-2"
})(["padding-left:", ";padding-top:", ";display:", ";", ""], function (props) {
  return props.hasCheckboxes ? 'var(--dentsu-spacing-32)' : 0;
}, function (props) {
  return props.pt ? props.pt : 'var(--dentsu-spacing-2)';
}, function (props) {
  return props.hasTruncation ? 'block' : 'inline-block';
}, function (props) {
  return props.hasTruncation && css(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
});
var CustomAbbr = styled.span.withConfig({
  displayName: "Selectstyles__CustomAbbr",
  componentId: "sc-p8f04v-3"
})(["font-weight:var(--dentsu-font-weight-semibold);display:inline-block;margin-right:", ";"], function (props) {
  return props.mr ? props.mr : 'var(--dentsu-spacing-16)';
});
var CustomInput = styled.input.withConfig({
  displayName: "Selectstyles__CustomInput",
  componentId: "sc-p8f04v-4"
})(["position:absolute;top:0;left:0;opacity:0;z-index:-1;"]);
export var Option = function Option(props) {
  var hasCheckboxes = props.selectProps.isMulti ? true : false;
  var hasAbbr = props.data.abbr ? true : false;
  return _jsx(components.Option, _objectSpread(_objectSpread({}, props), {}, {
    children: _jsxs(CustomOption, {
      children: [hasCheckboxes && _jsxs(_Fragment, {
        children: [_jsx(CustomInput, {
          type: "checkbox",
          checked: props.isSelected,
          onChange: function onChange() {
            return null;
          }
        }), _jsx(CustomIndicator, {
          isChecked: props.isSelected
        }), _jsxs(CustomLabel, {
          hasCheckboxes: hasCheckboxes,
          hasTruncation: props.selectProps.hasTruncation,
          children: [hasAbbr && _jsx(CustomAbbr, {
            children: props.data.abbr
          }), props.label]
        })]
      }), !hasCheckboxes && _jsxs(CustomLabel, {
        hasCheckboxes: hasCheckboxes,
        hasTruncation: props.selectProps.hasTruncation,
        children: [hasAbbr && _jsx(CustomAbbr, {
          children: props.data.abbr
        }), props.label]
      })]
    })
  }));
},
    OptionStyles = function OptionStyles(base, props) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: props.isFocused ? 'var(--dentsu-color-n50)' : props.isSelected ? 'var(--dentsu-color-n100)' : 'var(--dentsu-color-white)',
    color: 'var(--dentsu-color-n1000)',
    fontSize: 'var(--dentsu-font-size-14)',
    letterSpacing: 'var(--dentsu-tracking-normal)',
    marginBottom: 0,
    minHeight: rem(24),
    padding: 'var(--dentsu-spacing-8) var(--dentsu-spacing-16)',
    opacity: props.isDisabled ? 0.4 : 1,
    ':hover': {
      backgroundColor: 'var(--dentsu-color-n50)',
      cursor: props.isDisabled ? 'not-allowed' : 'default'
    }
  });
};
export var GroupHeadingStyles = function GroupHeadingStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 'var(--dentsu-spacing-16) var(--dentsu-spacing-16) var(--dentsu-spacing-8)',
    fontWeight: 'var(--dentsu-font-weight-semibold)',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    color: 'var(--dentsu-color-n700)',
    lineHeight: 'var(--dentsu-leading-none)',
    fontSize: 'var(--dentsu-font-size-11)'
  });
};
export var MultiValueContainer = function MultiValueContainer(_ref) {
  var _selectProps$customVa, _selectProps$customLa;

  var selectProps = _ref.selectProps,
      data = _ref.data,
      props = _objectWithoutProperties(_ref, _excluded2);

  var valueKey = (_selectProps$customVa = selectProps === null || selectProps === void 0 ? void 0 : selectProps.customValueKey) !== null && _selectProps$customVa !== void 0 ? _selectProps$customVa : 'value';
  var labelKey = (_selectProps$customLa = selectProps === null || selectProps === void 0 ? void 0 : selectProps.customLabelKey) !== null && _selectProps$customLa !== void 0 ? _selectProps$customLa : 'label';
  var hasAllOption = selectProps !== null && selectProps !== void 0 && selectProps.allOption ? true : false;
  var selectableCount = selectProps.selectableOptionsCount;
  var selectedCount = selectProps.value.length;
  var allSelectedCount = hasAllOption ? selectedCount - 1 : selectedCount;
  var isAllSelected = allSelectedCount === selectableCount;
  var index = selectProps.value.findIndex(function (selected) {
    return selected[valueKey] === data[valueKey];
  });

  function renderMultiLabels() {
    var labelCount = selectProps.value.length;
    return selectProps.value.map(function (item, index) {
      var counter = index + 1;
      return _jsxs(React.Fragment, {
        children: [(item === null || item === void 0 ? void 0 : item.abbr) && _jsxs(_Fragment, {
          children: [_jsx(CustomAbbr, {
            mr: "0px",
            children: item.abbr
          }), ' ']
        }), _jsx(CustomLabel, {
          pt: "0rem",
          children: item[labelKey]
        }), counter < labelCount && ', ']
      }, index);
    });
  }

  function renderMessage() {
    if (isAllSelected) {
      if (selectProps !== null && selectProps !== void 0 && selectProps.allSelectedMessage) {
        return selectProps.allSelectedMessage(allSelectedCount);
      } else {
        return "All ".concat(allSelectedCount, " selected");
      }
    } else {
      if (selectProps !== null && selectProps !== void 0 && selectProps.someSelectedMessage) {
        return _jsxs(_Fragment, {
          children: [selectProps.someSelectedMessage(selectedCount), ' ', renderMultiLabels()]
        });
      } else {
        return _jsxs(_Fragment, {
          children: [selectedCount > 1 ? "".concat(selectedCount, " selected.") : '', ' ', renderMultiLabels()]
        });
      }
    }
  }

  return _jsx("div", {
    className: "selected-value",
    children: index > 0 ? '' : renderMessage()
  });
},
    MultiValueContainerStyles = function MultiValueContainerStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: 'var(--dentsu-color-n100)',
    border: '1px solid var(--dentsu-color-n250)',
    borderRadius: 'var(--dentsu-radius-12)',
    height: rem(24),
    margin: 'var(--dentsu-spacing-4)',
    paddingLeft: 'var(--dentsu-spacing-12)',
    paddingRight: 0,
    maxWidth: 'calc(100% - var(--dentsu-spacing-12))'
  });
};
export var MultiValueLabelStyles = function MultiValueLabelStyles(base, state) {
  return {
    color: 'var(--dentsu-color-n1000)',
    display: 'block',
    fontSize: 'var(--dentsu-font-size-12)',
    lineHeight: 'var(--dentsu-leading-none)',
    letterSpacing: 'var(--dentsu-tracking-normal)',
    margin: 'auto',
    padding: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
};
export var MultiValueRemove = function MultiValueRemove(props) {
  return _jsx(components.MultiValueRemove, _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx(Icon, {
      icon: "cross",
      color: "var(--dentsu-color-b550)",
      size: 12
    })
  }));
},
    MultiValueRemoveStyles = function MultiValueRemoveStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    backgroundColor: 'var(--dentsu-color-n100)',
    border: '1px solid var(--dentsu-color-n250)',
    width: rem(22),
    height: rem(22),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    margin: 'auto 0 auto var(--dentsu-spacing-8)',
    lineHeight: 'var(--dentsu-leading-none)',
    outline: '0 none',
    flex: '0 0 auto',
    ':hover': {
      backgroundColor: 'var(--dentsu-color-n50)',
      cursor: 'pointer'
    }
  });
};
export var PlaceholderStyles = function PlaceholderStyles(base, state) {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: state.selectProps.isInvalid ? 'var(--dentsu-color-n1000)' : 'var(--dentsu-color-n700)',
    fontSize: 'var(--dentsu-font-size-14)',
    margin: 0
  });
};
export var SingleValue = function SingleValue(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded3);

  var hasAbbr = props.data.abbr ? true : false;
  return _jsxs(components.SingleValue, _objectSpread(_objectSpread({}, props), {}, {
    children: [hasAbbr && _jsx(CustomAbbr, {
      children: props.data.abbr
    }), _jsx(CustomLabel, {
      children: children
    })]
  }));
},
    SingleValueStyles = function SingleValueStyles(base, state) {
  return {
    color: 'var(--dentsu-color-n1000)',
    fontSize: 'var(--dentsu-font-size-14)',
    maxWidth: 'calc(100% - var(--dentsu-spacing-12))',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
};
export var ValueContainerStyles = function ValueContainerStyles(base, props) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 'var(--dentsu-spacing-4) var(--dentsu-spacing-16)',
    overflow: 'hidden',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexWrap: 'nowrap',
    '.selected-value': {
      fontSize: 'var(--dentsu-font-size-14)',
      letterSpacing: 'var(--dentsu-tracking-normal)',
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    label: {
      display: 'inline'
    }
  });
};
export var StyledSelectNative = styled.select.withConfig({
  displayName: "Selectstyles__StyledSelectNative",
  componentId: "sc-p8f04v-5"
})(["background-color:", ";background-image:", ";background-repeat:no-repeat;background-position:right var(--dentsu-spacing-16) top 50%,0 0;display:block;margin:0;padding:var(--dentsu-spacing-8) var(--dentsu-spacing-24) var(--dentsu-spacing-8) var(--dentsu-spacing-16);width:100%;max-width:", ";min-height:", ";box-sizing:border-box;font-size:var(--dentsu-font-size-14);letter-spacing:var(--dentsu-tracking-normal);color:var(--dentsu-color-n1000);border:none;border-radius:0;box-shadow:inset 0 1px 0 0 var(--dentsu-color-n300);-moz-appearance:none;-webkit-appearance:none;appearance:none;&.", "-select--fullwidth{max-width:none;}&[aria-invalid='true']{background-color:var(--dentsu-color-r100);box-shadow:inset 0 1px 0 0 var(--dentsu-color-r500);&:hover{background-color:var(--dentsu-color-r150);}&::placeholder{color:var(--dentsu-color-n650);}}&:hover{background-color:var(--dentsu-color-n100);cursor:default;&:focus{background-color:var(--dentsu-color-white);}}&:focus{background-color:var(--dentsu-color-white);box-shadow:inset 0 1px 0 0 var(--dentsu-color-fuchsia),var(--dentsu-shadow-8);outline:none;}&:disabled{opacity:0.4;cursor:not-allowed;}"], theme('mode', {
  light: 'var(--dentsu-color-n50)',
  grey: 'var(--dentsu-color-white)'
}), function (props) {
  return props.isMulti ? "none" : "url(\"data:image/svg+xml,%0A%3Csvg width='10px' height='6px' viewBox='0 0 10 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Icon-Library' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='*IconLIbrary-ForOverrides/Interface/chevron-down' transform='translate(-3.000000, -5.000000)' fill='%230660C8'%3E%3Cpath d='M12,4.99999998 C11.72,4.99999998 11.47,5.10999998 11.29,5.28999998 L7.99999997,8.59 L4.70999998,5.28999998 C4.52999998,5.10999998 4.27999998,4.99999998 3.99999997,4.99999998 C3.44999997,4.99999998 2.99999997,5.44999998 2.99999997,5.99999998 C2.99999997,6.27999999 3.10999997,6.52999999 3.28999997,6.70999999 L7.29,10.71 C7.47,10.89 7.72,11 7.99999997,11 C8.28,11 8.53,10.89 8.71,10.71 L12.71,6.70999999 C12.89,6.52999999 13,6.27999999 13,5.99999998 C13,5.44999998 12.55,4.99999998 12,4.99999998 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")";
}, rem(400), rem(40), prefix);

var selectWidth = function selectWidth(props) {
  if (typeof props.width === 'number') {
    return props.width + 'px';
  } else {
    return props.width;
  }
};

export var StyledSelect = styled(ReactSelect).withConfig({
  displayName: "Selectstyles__StyledSelect",
  componentId: "sc-p8f04v-6"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? selectWidth : '100%';
});
export var StyledSelectAsync = styled(ReactSelectAsync).withConfig({
  displayName: "Selectstyles__StyledSelectAsync",
  componentId: "sc-p8f04v-7"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? selectWidth : '100%';
});
export var StyledSelectCreatable = styled(ReactSelectCreatable).withConfig({
  displayName: "Selectstyles__StyledSelectCreatable",
  componentId: "sc-p8f04v-8"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? selectWidth : '100%';
});
export var StyledSelectCreatableAsync = styled(ReactSelectAsyncCreatable).withConfig({
  displayName: "Selectstyles__StyledSelectCreatableAsync",
  componentId: "sc-p8f04v-9"
})(["max-width:", ";width:", ";"], function (props) {
  return props.isFullWidth || props.width ? 'none' : rem(400);
}, function (props) {
  return props.width ? selectWidth : '100%';
});